import t from "@theme-ui/preset-base";

function a() {
  return (a = Object.assign || function (t) {
    for (var a = 1; a < arguments.length; a++) {
      var r = arguments[a];

      for (var e in r) {
        Object.prototype.hasOwnProperty.call(r, e) && (t[e] = r[e]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var r = a({}, t, {
  colors: a({}, t.colors, {
    text: "#000",
    background: "#FFF",
    primary: "#0E6A9C",
    secondary: "#266F37",
    forumBlue: "#00609D",
    blue: "#0E6A9C",
    green: "#266F37",
    red: "#A21723",
    yellow: "#C59B25",
    gray: "#717171"
  }),
  breakpoints: ["30em", "60em"],
  borders: [0, "1px solid", "2px solid", "3px solid"],
  radii: {
    default: 0,
    circle: 99999
  },
  badges: {
    default: {
      borderRadius: "default"
    },
    primary: {
      color: "background",
      bg: "primary",
      variant: "badges.default"
    },
    secondary: {
      color: "background",
      bg: "secondary",
      variant: "badges.default"
    }
  },
  buttons: {
    default: {
      fontSize: 2,
      fontWeight: "bold",
      borderRadius: "default"
    },
    primary: {
      variant: "buttons.default",
      color: "background",
      bg: "primary"
    },
    secondary: {
      variant: "buttons.default",
      color: "background",
      bg: "secondary"
    },
    outline: {
      default: {
        variant: "buttons.default",
        boxShadow: "0 0 0 2px inset",
        bg: "inherit"
      },
      primary: {
        variant: "buttons.outline.default",
        color: "primary"
      },
      secondary: {
        variant: "buttons.outline.default",
        color: "secondary"
      }
    }
  },
  layout: {
    container: {
      px: [2, 3, 4],
      maxWidth: "64rem"
    },
    narrow: {
      variant: "layout.container",
      maxWidth: "48rem"
    },
    wide: {
      variant: "layout.container",
      maxWidth: "96rem"
    }
  },
  "event-preview": {
    badge: {
      variant: "badges.primary"
    },
    buttons: {
      event: {
        variant: "buttons.primary"
      },
      registration: {
        variant: "buttons.outline.primary"
      }
    }
  },
  footer: {
    bg: "primary"
  },
  header: {
    color: "primary",
    bg: "background",
    container: {
      variant: "layout.wide"
    },
    nav: {
      bg: "background"
    },
    cta: {
      variant: "buttons.outline.primary"
    }
  },
  names: {
    default: {
      fontWeight: "body"
    },
    bold: {
      fontWeight: "bold"
    }
  },
  "post-preview": {
    badge: {
      variant: "badges.primary"
    },
    button: {
      variant: "buttons.primary"
    }
  },
  tags: {
    default: {
      borderRadius: "default"
    },
    primary: {
      color: "background",
      bg: "primary",
      variant: "tags.default"
    },
    secondary: {
      color: "background",
      bg: "secondary",
      variant: "tags.default"
    }
  },
  styles: a({}, t.styles, {
    h1: a({}, t.styles.h1, {
      mt: 0,
      mb: 4
    }),
    h2: a({}, t.styles.h2, {
      mt: 0,
      mb: 3
    }),
    h3: a({}, t.styles.h3, {
      mt: 0,
      mb: 2
    }),
    h4: a({}, t.styles.h4, {
      mt: 0,
      mb: 2
    }),
    h5: a({}, t.styles.h5, {
      mt: 0,
      mb: 2
    }),
    h6: a({}, t.styles.h6, {
      mt: 0,
      mb: 2
    }),
    p: a({}, t.styles.p, {
      color: "inherit",
      mt: 0,
      mb: 3,
      "&:last-child": {
        mb: 0
      }
    }),
    a: a({}, t.styles.a, {
      textDecoration: "none",
      "@media (hover: hover)": {
        "&:hover": {
          textDecoration: "underline"
        }
      },
      WebkitTapHighlightColor: "transparent"
    })
  })
});
export default r;